import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { OutboundLink } from 'react-ga'
import classNames from 'classnames'
import styles from '../styles/Footer.module.scss'

const Footer = () => (
  <div className={styles.container}>
    <div className={styles.containerInner}>
      <div
        className={classNames(
          'd-sm-none d-md-flex',
          styles.row,
          styles.vertical
        )}
      >
        <Link to='/about-us'>About Us</Link>
        <Link to='/contact-us'>Contact</Link>
        <Link to='/privacy'>Privacy Policy</Link>
      </div>
      <div className={styles.row}>
        <OutboundLink
          eventLabel='https://www.facebook.com/EDHREC1'
          target='_blank'
          to='https://www.facebook.com/EDHREC1'
        >
          <FontAwesomeIcon icon='fa-brands fa-facebook' />
        </OutboundLink>
        <OutboundLink
          eventLabel='https://www.instagram.com/EDHREC'
          target='_blank'
          to='https://www.instagram.com/EDHREC'
        >
          <FontAwesomeIcon icon='fa-brands fa-instagram' />
        </OutboundLink>
        <OutboundLink
          eventLabel='https://edhrec.com/articles/feed/?cat=4'
          target='_blank'
          to='https://edhrec.com/articles/feed/?cat=4'
        >
          <FontAwesomeIcon icon='rss-square' />
        </OutboundLink>
        <OutboundLink
          eventLabel='https://www.tiktok.com/@edhrec'
          target='_blank'
          to='https://www.tiktok.com/@edhrec'
        >
          <FontAwesomeIcon icon='fa-brands fa-tiktok' />
        </OutboundLink>
        <OutboundLink
          eventLabel='https://www.twitch.tv/EDHRECast'
          target='_blank'
          to='https://www.twitch.tv/EDHRECast'
        >
          <FontAwesomeIcon icon='fa-brands fa-twitch' />
        </OutboundLink>
        <OutboundLink
          eventLabel='https://www.twitter.com/EDHREC'
          target='_blank'
          to='https://www.twitter.com/EDHREC'
        >
          <FontAwesomeIcon icon='fa-brands fa-twitter' />
        </OutboundLink>
        <OutboundLink
          eventLabel='https://www.youtube.com/EDHRECast'
          target='_blank'
          to='https://www.youtube.com/EDHRECast'
        >
          <FontAwesomeIcon icon='fa-brands fa-youtube' />
        </OutboundLink>
      </div>
      <div
        className={classNames(
          'd-sm-none d-md-flex',
          styles.row,
          styles.vertical
        )}
      >
        <OutboundLink
          className={styles.scm}
          eventLabel='https://spacecowmedia.com/'
          rel='noopener noreferrer'
          target='_blank'
          to='https://spacecowmedia.com/'
        >
          Space Cow Media
        </OutboundLink>
        <OutboundLink
          className='d-none d-md-flex'
          eventLabel='https://archidekt.com/'
          rel='noopener noreferrer'
          target='_blank'
          to='https://archidekt.com/'
        >
          Archidekt
        </OutboundLink>
        <OutboundLink
          className='d-none d-md-flex'
          eventLabel='https://commandersherald.com/'
          rel='noopener noreferrer'
          target='_blank'
          to='https://commandersherald.com/'
        >
          Commander's Herald
        </OutboundLink>
        <OutboundLink
          className='d-none d-md-flex'
          eventLabel='https://commanderspellbook.com/'
          rel='noopener noreferrer'
          target='_blank'
          to='https://commanderspellbook.com/'
        >
          Commander Spellbook
        </OutboundLink>
        <OutboundLink
          className='d-none d-md-flex'
          eventLabel='https://fabrec.gg/'
          rel='noopener noreferrer'
          target='_blank'
          to='https://fabrec.gg/'
        >
          FABREC
        </OutboundLink>
        <OutboundLink
          className='d-none d-md-flex'
          eventLabel='https://spellvoid.com/'
          rel='noopener noreferrer'
          target='_blank'
          to='https://spellvoid.com/'
        >
          Spellvoid
        </OutboundLink>
      </div>
      <div className={classNames('d-none d-sm-flex d-md-none', styles.row)}>
        <OutboundLink
          className={styles.scm}
          eventLabel='https://spacecowmedia.com/'
          rel='noopener noreferrer'
          target='_blank'
          to='https://spacecowmedia.com/'
        >
          Space Cow Media
        </OutboundLink>
        <OutboundLink
          eventLabel='https://archidekt.com/'
          rel='noopener noreferrer'
          target='_blank'
          to='https://archidekt.com/'
        >
          Archidekt
        </OutboundLink>
        <OutboundLink
          eventLabel='https://commandersherald.com/'
          rel='noopener noreferrer'
          target='_blank'
          to='https://commandersherald.com/'
        >
          Commander's Herald
        </OutboundLink>
      </div>
      <div className={classNames('d-none d-sm-flex d-md-none', styles.row)}>
        <OutboundLink
          eventLabel='https://commanderspellbook.com/'
          rel='noopener noreferrer'
          target='_blank'
          to='https://commanderspellbook.com/'
        >
          Commander Spellbook
        </OutboundLink>
        <OutboundLink
          eventLabel='https://fabrec.gg/'
          rel='noopener noreferrer'
          target='_blank'
          to='https://fabrec.gg/'
        >
          FABREC
        </OutboundLink>
        <OutboundLink
          eventLabel='https://spellvoid.com/'
          rel='noopener noreferrer'
          target='_blank'
          to='https://spellvoid.com/'
        >
          Spellvoid
        </OutboundLink>
      </div>
      <div className={styles.row}>
        <b>Exclusive Member of Mediavine Home</b>
      </div>
    </div>
  </div>
)

export default Footer
